import DeleteIcon from "@mui/icons-material/Delete";
import {
  Autocomplete,
  Box,
  Button,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";
import { useState } from "react";
import { Categorie } from "../../../models/Categorie";
import { Departement } from "../../../models/Departement";
import { Fournisseur } from "../../../models/Fournisseur";
import { Gamme } from "../../../models/Gamme";
import { RequestToSend } from "../../../models/RequestToSend";
import { addRequestToSend } from "../../../redux/features/appStateSlice";
import {
  planoAPI,
  useAddSelectionMutation,
  useLazyGetQueriesQuery,
} from "../../../redux/features/cache";
import { useAppDispatch, useAppSelector } from "../../../redux/store";

interface SelectionFormProps {
  plans_seq: number | undefined;
  setAddSelection: any;
}

export default function SelectionForm({
  plans_seq,
  setAddSelection,
}: SelectionFormProps) {
  const dispatch = useAppDispatch();

  const [dirty, setDirty] = useState<boolean>(false);

  const [getQueries] = planoAPI.endpoints.getQueries.useLazyQuery();
  const [addSelection] = planoAPI.endpoints.addSelection.useMutation();

  const [departments, setDepartments] = useState<Departement[]>([]);
  const [defaultDepartment, setDefaultDepartment] = useState<Departement | null>();

  const [suppliers, setSuppliers] = useState<Fournisseur[]>([]);
  const [defaultSupplier, setDefaultSupplier] = useState<Fournisseur | null>();
  
  const [productLines, setProductLines] = useState<Gamme[]>([]);
  const [defaultProductLine, setDefaultProductLine] = useState<Gamme | null>();

  const [categories, setCategories] = useState<Categorie[]>([]);
  const [defaultCategorie, setDefaultCategorie] = useState<Categorie | null>();
  
  const [defaultMode, setDefaultMode] = useState<boolean>(true);
  
  const d_inv026 = useAppSelector((state) => state.appState.d_inv026);

  const getAutocomplete = async (
    event: any,
    queries: string,
    setState: any
  ) => {
    if (event !== null) {
      let rech = event.target.value;
      if (rech) {
        let result = await getQueries(
          { queries, rech, treeView: false },
          true
        ).unwrap();
        setState(result);
      } else {
        setState([]);
      }
    }
  };

  const handleSub = async () => {
    let selection = {
      plans_seq: plans_seq,
      planss_mode: defaultMode,
      dept_cd: defaultDepartment !== null ? defaultDepartment?.dept_cd : "",
      cat_cd: defaultCategorie !== null ? defaultCategorie?.cat_cd : "",
      four_cd: defaultSupplier !== null ? defaultSupplier?.four_cd : "",
      gamme_cd: defaultProductLine !== null ? defaultProductLine?.gamme_cd : "",
    };
    dispatch(
      addRequestToSend(
        new RequestToSend(
          `Ajout sélection pour section ${plans_seq}`,
          addSelection,
          () => {
            setAddSelection(false);
          },
          {},
          selection,
          []
        )
      )
    );
  };

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", pt: 2 }}>
        <TextField
          label="Mode"
          sx={{ width: "7vw", p: 1, mr: 3 }}
          onChange={(e) => {
            setDirty(true);
            setDefaultMode(e.target.value === "true");
          }}
          defaultValue={defaultMode}
          select
        >
          <MenuItem value={true as any}>Inclus</MenuItem>
          <MenuItem value={false as any}>Exclus</MenuItem>
        </TextField>
        <Autocomplete
          options={departments}
          clearOnBlur={false}
          defaultValue={defaultDepartment}
          getOptionLabel={(cat) => `${cat.dept_cd} ${cat.dept_nom}`}
          onChange={(e, data) => {
            setDirty(true);
            setDefaultDepartment(data);
          }}
          onInputChange={(event) => {
            getAutocomplete(event, "departement", setDepartments);
          }}
          sx={{ width: "15vw", p: 1 }}
          renderInput={(params) => (
            <TextField
              sx={{
                color: "red",
              }}
              {...params}
              label="Departement"
            />
          )}
        />
        <Autocomplete
          options={categories}
          clearOnBlur={false}
          getOptionLabel={(cat) => `${cat.cat_cd} ${cat.cat_descr}`}
          defaultValue={defaultCategorie}
          onChange={(e, data) => {
            setDirty(true);
            setDefaultCategorie(data);
          }}
          onInputChange={(event) => {
            getAutocomplete(event, "categories", setCategories);
          }}
          sx={{ width: "15vw", p: 1 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Categories"
            />
          )}
        />
        <Autocomplete
          options={suppliers}
          clearOnBlur={false}
          defaultValue={defaultSupplier}
          getOptionLabel={(cat) => `${cat.four_cd} ${cat.four_nom}`}
          onChange={(e, data) => {
            setDirty(true);
            setDefaultSupplier(data);
          }}
          onInputChange={(event) => {
            getAutocomplete(event, "fournisseur", setSuppliers);
          }}
          sx={{ width: "15vw", p: 1 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Fournisseur"
            />
          )}
        />
        <Autocomplete
          options={productLines}
          clearOnBlur={false}
          defaultValue={defaultProductLine}
          getOptionLabel={(cat) => `${cat.gamme_cd} ${cat.gamme_descr}`}
          onChange={(e, data) => {
            setDirty(true);
            setDefaultProductLine(data);
          }}
          onInputChange={(event) => {
            getAutocomplete(event, "gamme", setProductLines);
          }}
          sx={{ width: "15vw", p: 1 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Gamme"
            />
          )}
        />

        <Tooltip title="Enregistrer">
          <span
            style={{
              display: "flex",
              alignItems: "center",
              padding: "6px 28px",
              cursor: "pointer",
            }}
            className={`save-wrapper ${!dirty ? "custom-disabled" : ""}`}
          >
            <span
              className={`k-icon k-font-icon k-i-save k-icon-xl`}
              onClick={handleSub}
            ></span>
          </span>
        </Tooltip>
        <Tooltip title="Annuler">
          <span style={{ display: "flex" }}>
            <Button
              disabled={!d_inv026.canDelete}
              onClick={() => setAddSelection(false)}
              color="error"
            >
              <DeleteIcon />{" "}
            </Button>
          </span>
        </Tooltip>
      </Box>
    </>
  );
}
